import React from "react";

const FullStackImg = ({className}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1019.4842"
      height="436.68123"
      viewBox="0 0 1019.4842 436.68123"
      // xmlns:xlink="http://www.w3.org/1999/xlink"
      role="img"
      artist="Katerina Limpitsouni"
      source="https://undraw.co/"
      className={className}
    >
      <path
        d="M1053.535,231.65939H414.15223a17.59849,17.59849,0,0,0-17.59851,17.59849v356.2522a17.59854,17.59854,0,0,0,17.59851,17.59857H1053.535a17.59856,17.59856,0,0,0,17.59851-17.59857V249.25788a17.59852,17.59852,0,0,0-17.59851-17.59849Z"
        transform="translate(-90.2579 -231.65939)"
        fill="#3f3d56"
      />
      <rect
        x="329.89003"
        y="31.10145"
        width="627.39127"
        height="353.91303"
        fill="#fff"
      />
      <circle cx="643.04942" cy="15.01449" r="6.43477" fill="#fff" />
      <polygon
        points="777.858 385.015 329.89 385.015 329.89 31.102 777.858 385.015"
        fill="#f2f2f2"
        style={{ isolation: "isolate" }}
      />
      <circle cx="428.05798" cy="298.22423" r="60.3068" fill="#2C55E5" />
      <path
        d="M531.74082,575.21a75.01577,75.01577,0,1,1,75.01581-75.01575A75.01578,75.01578,0,0,1,531.74082,575.21Zm0-149.051A74.03519,74.03519,0,1,0,605.776,500.19428a74.03518,74.03518,0,0,0-74.03522-74.03521Z"
        transform="translate(-90.2579 -231.65939)"
        fill="#3f3d56"
      />
      <rect
        x="753.43694"
        y="214.96957"
        width="58.60522"
        height="12.24586"
        fill="#3f3d56"
      />
      <rect
        x="697.99083"
        y="148.62679"
        width="169.49743"
        height="5.24823"
        fill="#3f3d56"
      />
      <rect
        x="697.99083"
        y="169.24617"
        width="169.49743"
        height="5.24823"
        fill="#3f3d56"
      />
      <rect
        x="697.99083"
        y="189.86555"
        width="169.49743"
        height="5.24823"
        fill="#3f3d56"
      />
      <rect
        x="888.40147"
        y="52.28163"
        width="24.49176"
        height="24.49173"
        fill="#2C55E5"
      />
      <path
        d="M1014.52225,319.8039h-29.74v-29.74h29.74Zm-28.4469-1.293h27.15381V291.357H986.07529Z"
        transform="translate(-90.2579 -231.65939)"
        fill="#ccc"
      />
      <path
        d="M1088.74918,610.23908h-61.22937v-4.41156a.87466.87466,0,0,0-.87463-.87469h-20.993a.87468.87468,0,0,0-.87476.87463v4.41162H991.657v-4.41156a.87468.87468,0,0,0-.8747-.87469H969.7894a.87467.87467,0,0,0-.87469.87469h0v4.41156H955.79416v-4.41156a.87467.87467,0,0,0-.87469-.87469h-20.993a.87468.87468,0,0,0-.8747.87469h0v4.41156H919.93125v-4.41156a.87468.87468,0,0,0-.8747-.87469H898.06363a.87466.87466,0,0,0-.87469.87463v4.41162H884.0684v-4.41156a.87468.87468,0,0,0-.8747-.87469H862.20078a.87467.87467,0,0,0-.87469.87469h0v4.41156H848.20548v-4.41156a.87467.87467,0,0,0-.87469-.87469H826.33787a.87468.87468,0,0,0-.8747.87469h0v4.41156H812.34263v-4.41156a.87468.87468,0,0,0-.8747-.87469H647.02347a.87467.87467,0,0,0-.87469.87469h0v4.41156H633.02817v-4.41156a.87467.87467,0,0,0-.87469-.87469H611.16062a.87468.87468,0,0,0-.8747.87469h0v4.41156h-13.1206v-4.41156a.87466.87466,0,0,0-.87463-.87469h-20.993a.87467.87467,0,0,0-.87469.87469h0v4.41156H561.3024v-4.41156a.87467.87467,0,0,0-.87469-.87469H539.43479a.87468.87468,0,0,0-.8747.87469h0v4.41156H525.43955v-4.41156a.87467.87467,0,0,0-.87469-.87469H503.57194a.87468.87468,0,0,0-.8747.87469h0v4.41156h-13.1206v-4.41156a.87468.87468,0,0,0-.8747-.87469H467.709a.87468.87468,0,0,0-.87469.87463v4.41162H453.71375v-4.41156a.87467.87467,0,0,0-.87466-.87469H431.84617a.8747.8747,0,0,0-.8747.87469h0v4.41156H390.735A20.99292,20.99292,0,0,0,369.74213,631.232v9.4925A20.99291,20.99291,0,0,0,390.735,661.71736h698.01416a20.99293,20.99293,0,0,0,20.99292-20.99286V631.232A20.9929,20.9929,0,0,0,1088.74918,610.23908Z"
        transform="translate(-90.2579 -231.65939)"
        fill="#3f3d56"
      />
    </svg>
  );
};

export default FullStackImg;
